module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNI"
  }, [_vm._v("Once again I’d like to thank: my editor, Monique Patterson, for helping me get the best out of Alex and Katya’s story. My agent, Helen Breitweiser, for ensuring that Alex and Katya actually have a story. My dauntless critique partner and awesome friend, Maisey Yates for making sure there was an Alex and Katya to write about. My husband, the good Dr. Jax, and my two lovely girls, for supporting me while I wrote them. And lastly, to all the readers who (hopefully) will want to finally read about them!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b285ee4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0